<template>
<div>
   
    <v-text-field
        prepend-icon="mdi-magnify"
        label="Search Phone Numbers"
        style="margin-top: 15px;"
        v-model="search_text"
        autocomplete="off"
    />

    <v-data-table
        :headers="phone_number_headers"
        :items="my_items"
        :search="search_text"
        :items-per-page="100"
        :hide-default-footer="true"
        class="elevation-1"
        style="margin-top: 15px; margin-bottom: 15px;"

        :footer-props="{
            disableItemsPerPage: true,
            disablePagination: true,
            }"
    >
       <template v-slot:item.endpoint="{ item }">
            {{prettyPrintUsPhoneNumber(item.endpoint)}}
        </template>

        <template v-slot:item.toll_free="{ item }">
            {{prettyPrintTollFree(item)}}
        </template>

        

        <template v-slot:item.assignment="{ item }">
            {{prettyPrintAssignment(item)}}
        </template>

        <template v-slot:item.assigned_to_label="{ item }">
            {{assignedToLabel(item)}}
        </template>

        <template v-slot:item.is_primary="{ item }">
            <v-simple-checkbox v-model="item.is_primary" disabled></v-simple-checkbox>
        </template>

        <template v-slot:item.complimentary_endpoint="{ item }">
            <v-simple-checkbox
                v-model="item.complimentary_endpoint"
                disabled
            />
        </template>

        <template v-slot:item.expected_to_be_in_service="{ item }">
            <v-simple-checkbox
                v-model="item.expected_to_be_in_service"
                disabled
            />
        </template>

        <template v-slot:item.supports_voice="{ item }">
            <v-simple-checkbox
            v-model="item.supports_voice"
            disabled
            ></v-simple-checkbox>
        </template>

        <template v-slot:item.supports_messaging="{ item }">
            <v-simple-checkbox
            v-model="item.supports_messaging"
            disabled
            ></v-simple-checkbox>
        </template>

        

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y
            >
                
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>

                    <v-list-item
                        v-on:click="onClickChangeLabel(item)"
                        v-show="can_write"
                    >
                        <v-list-item-title>Change Label...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="viewConversations($event, item)"
                    >
                        <v-list-item-title>View Conversations...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="signInAs(item)"
                        v-if="is_sys_admin && item.assigned_to_employee_id != null"
                    >
                        <v-list-item-title>Sign In As...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="makeAvailable(item)"
                        v-show="can_write && item.assignment != 'available'"
                    >
                        <v-list-item-title>Make Available...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="startAssignToEmployee(item)"
                        v-show="can_write"
                    >
                        <v-list-item-title>Assign to User...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="startAssignToTeam(item)"
                        v-show="can_write"
                    >
                        <v-list-item-title>Assign to Team...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="makeOrganizationBot(item)"
                        v-show="can_write && item.assignment != 'assigned-to-organization-bot'"
                    >
                        <v-list-item-title>Assign to Organization Bot...</v-list-item-title>
                    </v-list-item>

                    

                    <v-list-item
                        v-on:click="makePrimary(item)"
                        v-show="can_write && !item.is_primary && item.assignment == 'assigned-to-organization-bot'"
                    >
                        <v-list-item-title>Make primary...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="toggleComplimentary(item)"
                        v-if="is_sys_admin"
                    >
                        <v-list-item-title>Toggle Complimentary</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickTeamVoiceSettings(item)"
                        v-if="item.assignment == 'assigned-to-employee-group'"
                        v-show="can_write"
                    >
                        <v-list-item-title>Team Number Voice Settings...</v-list-item-title>
                    </v-list-item>

                     <v-list-item
                        v-on:click="onClickEndpointUnavailableAutoResponse(item)"
                        v-if="item.assignment != 'assigned-to-employee' && item.assignment != 'assigned-to-organization-bot'"
                        v-show="can_write"
                    >
                        <v-list-item-title>Unavailable Auto Response...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickCustomizeBotAutoResponse(item)"
                        v-if="item.assignment == 'assigned-to-organization-bot'"
                        v-show="can_write"
                    >
                        <v-list-item-title>Customize bot auto response...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickEditContactCards(item)"
                        v-show="can_write"
                    >
                        <v-list-item-title>Edit contact cards...</v-list-item-title>
                    </v-list-item>

                </v-list>
            </v-menu>


        </template>

    </v-data-table>

     <m-icon-bar
        v-on:add="showAddPhoneNumberDialog"
        v-show="can_write"
    />

    <m-settings-organization-dialog-select-team
        ref="select_team"
        v-on:ok="assignEndpointToEmployee"
    />

    <m-settings-organization-dialog-select-team-member
        ref="select_team_member"
        v-on:ok="assignEndpointToEmployee"
    />

    <m-choose-vcard-dialog
        ref="edit-vcard-dialog"
        title="Edit contact cards"
        :action_text="null"
    />
    
</div>
</template>

<script>
const E164 = require("@/js/E164.js");
const _ = require('lodash');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            search_text: null,
        }
    },

    methods: 
    {
        prettyPrintUsPhoneNumber(endpoint)
        {
            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        

        prettyPrintTollFree(item)
        {
            if ( item.endpoint_subtype == 'ptsn-toll-free' ) return 'Toll Free';
            return 'Local';
        },

        assignedToLabel(item)
        {
            switch (item.assignment)
            {
                case "assigned-to-employee":
                {
                    return item.assigned_to_employee_username
                }
                case "assigned-to-employee-group":
                {
                    return item.assigned_to_employee_group_label;
                }
                default:
                {
                    return "";
                }
            }
        },

        prettyPrintAssignment(item)
        {
            let assignment = item.assignment;

            let dev_label = E164.getDevEndpointLabel(item.endpoint);
            if ( dev_label != null ) return dev_label;

            if ( assignment === 'assigned-to-employee' )
                return "RedChirp User";
            
            if ( assignment === 'assigned-to-organization-bot' )
                return "Organization Bot";

            if ( assignment === 'assigned-to-employee-group' )
                return "Assigned to Team"
            
            if ( assignment === 'available' )
                return "Available";

            return assignment;
        },

        onClickChangeLabel(item)
        {
            let number = this.prettyPrintUsPhoneNumber(item.endpoint);
            let assignment = item.assignment_label;
            let cur_label = item.label;

            let text = '<p>The label, and only the label, is visible to everyone in your organization when they view or search for this number.</p>';
            text += '<p>It should be concise and specific.  You can change this at any time.</p>';
            text += `<p><b>Phone Number: </b> ${number}<br/><b>Assignment: </b> ${assignment}<br/><b>Current Label: </b> ${cur_label}</p>`;


            this.$rc.prompt({
                'title' : 'Change Label',
                'text' : text,
                'label' : 'New label',
                'value' : item.label,
                'after_prompt' : (value) => {
                    if ( value == null ) return;
                    value = value.trim();
                    if ( value.length == 0 ) return;

                    let changes = {
                        'endpoint' : item.endpoint,
                        'label' : value,
                    };

                    this.$emit('patch-endpoint', changes);
                }
            });
        },


        viewConversations(event, endpoint)
        {
            this.$rc.toHomeForEndpoint(this.$router, endpoint.endpoint, event.shiftKey == true);
        },

        makeOrganizationBot(item)
        {
            let changes = {
                'endpoint' : item.endpoint,
                'assignment' : 'assigned-to-organization-bot',
                'label' : 'Bot'
            };

            this.$rc.confirm(
                    "Assign number to bot",
                    "Make "+this.prettyPrintUsPhoneNumber(item.endpoint)+" the number for the organization bot?",
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Confirm', 'value': 'confirm'},
                    ],

                    (response) => {
                        if (response == 'confirm') {
                            this.$emit('patch-endpoint', changes);
                        } else {
                            return;
                        }
                    }
                );
        },

        makeAvailable(item)
        {
            let changes = {
                'endpoint' : item.endpoint,
                'assignment' : 'available',
                'label' : 'Available'
            };

            this.$rc.confirm(
                    "Make Available",
                    "Make "+this.prettyPrintUsPhoneNumber(item.endpoint)+" an available (unassigned) number?",
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Confirm', 'value': 'confirm'},
                    ],

                    (response) => {
                        if (response == 'confirm') {
                            this.$emit('patch-endpoint', changes);
                        } else {
                            return;
                        }
                    }
                );
        },

        toggleComplimentary(item)
        {
            let changes = {
                'endpoint' : item.endpoint,
                'complimentary_endpoint' : !item.complimentary_endpoint,
            };

            
            this.$emit('patch-endpoint', changes);
            
        },

        onClickTeamVoiceSettings(item)
        {
            let endpoint = item.endpoint;
            let organization_id = item.organization_id;

            this.$router.push({
                'name': 'team-number-voice-settings',
                'params' : {
                    'organization_id' : organization_id,
                    'endpoint' : endpoint
                }
            }).catch(e=>{}); // swallow any exception
        },

        onClickEndpointUnavailableAutoResponse(item)
        {
            this.$router.push({
                'name': 'settings-organization-endpoint-unavailable-auto-response',
                'params' : {
                    'organization_id' : item.organization_id,
                    'endpoint' : item.endpoint
                }
            });
        },

        onClickCustomizeBotAutoResponse(item)
        {
            let cur_response = item.override_bot_auto_response;
            if ( cur_response == null ) cur_response = 'This number is used to send automated messages.  It does not accept incoming messages.';

            this.$rc.prompt({
                'title' : 'Customize bot auto response',
                'label' : 'Custom bot auto response',
                'textarea': true,
                'value' : cur_response,
                'after_prompt' : (value) => {

                    let changes = {
                        'endpoint' : item.endpoint,
                        'override_bot_auto_response' : value
                    };

                    this.$emit('patch-endpoint', changes);
                }
            });
        },

        onClickEditContactCards(item)
        {
            let search = {
                'organization_id': item.organization_id,
                'for_organization_owned_endpoint' : item.endpoint,
            };

            this.$refs['edit-vcard-dialog'].showDialog(search);
        },

        makePrimary(item)
        {
            let conf = confirm( "Make "+this.prettyPrintUsPhoneNumber(item.endpoint)+" primary?" );

            if ( conf != true )
                return;

            let changes = {
                'endpoint' : item.endpoint,
                'is_primary' : true
            };

            this.$emit('patch-endpoint', changes);
        },

        startAssignToTeam(item)
        {
            this.$refs['select_team'].showDialog(item.endpoint, this.profile.organization_account.groups, item.assigned_to_employee_group_id);
        },

        startAssignToEmployee(item)
        {
            this.$refs['select_team_member'].showDialog(item.endpoint, this.profile.employees, item.assigned_to_employee_id);
        },

        assignEndpointToEmployee(changes)
        {
            this.$emit('patch-endpoint', changes);
        },

        showAddPhoneNumberDialog()
        {
            this.$emit('show-phone-number-dialog');
        },

        signInAs(item)
        {
             this.$rc.newSignInAs(
                {
                    'organization_id': item.organization_id,
                    'employee_id': item.assigned_to_employee_id,
                }
            );
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

         phone_number_headers() {

            let ret = [
                { text: 'Phone Number', value: 'endpoint' },
                { text: 'Active', value: 'expected_to_be_in_service' },
                { text: 'Voice', value: 'supports_voice' },
                { text: 'Messaging', value: 'supports_messaging' },
                { text: 'Type', value: 'toll_free' },
                { text: 'Assignment', value: 'assignment_label' },
                { text: 'Label', value: 'label' },
                { text: 'Action', value: 'action', align: 'end' },
            ];

            if ( this.profile != null && this.profile.actor_permissions.is_system_admin == true )
            {
                ret.splice(5,0,{ text: 'Network', value: 'network' });
                ret.splice(8,0,{ text: 'Complimentary', value: 'complimentary_endpoint' });
            }

            return ret;
         },

         is_sys_admin() {
            return this.$rc.$state.isSystemsAdmin(); 
        },

        my_items()
        {
            let ret = [];
            let src = this.profile.endpoints;

            for ( let i = 0; i < src.length; i++ )
            {
                let item = _.cloneDeep(src[i]);
                item.assigned_to_label = this.assignedToLabel(item);
                ret.push(item);
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>